{
  "EMOJI": {
    "PLACEHOLDER": "Rechercher des émojis",
    "NOT_FOUND": "Aucun émoji ne correspond à votre recherche",
    "REMOVE": "Supprimer"
  }
}
